<template>
  <Card>
    <v-card-title class="pa-0">{{ $t('Возврат процедуры № {_1} на стадию "Приём заявок"', { '_1': registryNumber }) }}<v-icon
        class="close-button"
        @click.native="closeDialog"
      >mdi-close</v-icon>
    </v-card-title>
    <v-card-subtitle class="px-0">{{ $t('Определите параметры проведения процедуры') }}</v-card-subtitle>
    <component
        v-if="stageComponent"
        ref="stages"
        class="stages"
        :is="stageComponent"
        :procedure="procedure"
        :errors="errors"
        :only-dates="true"
        :append-to-body="false"
        :disabled-date="pickersDisabledDate"
    />
    <v-card-subtitle class="px-0">{{ $t('Приём заявок начнётся сразу после возврата процедуры') }}</v-card-subtitle>
    <div>
      <v-textarea
        :rows="3"
        maxlength="2000"
        v-model="procedure.reacceptanceExplanation"
        variant="outlined"
        hide-details
        :placeholder="$t('Укажите информацию о причинах возврата процедуры')"
      />
    </div>
    <v-card-actions
        class="flex-row pa-0 py-1 pb-1"
    >
      <v-btn
        color="primary"
        variant="elevated"
        @click.native="approve"
        class="action-button"
      >{{ $t('Опубликовать') }}</v-btn>
    </v-card-actions>
  </Card>
</template>

<script setup lang="ts">
import Card from '@intec/vue-components/form/Card.vue';
import { useProcedureStageComponentStore } from '@/stores/procedureStageComponentStore';
import { useDialogStore } from '@/stores/dialog';
import { computed, ref } from 'vue';
import api from '@/api';
import { toast } from '@/lib/toast';

interface Props {
  procedure: {
    Object,
    required: true,
  },
  onSuccess: () => Promise<void>,
}

const props = withDefaults(defineProps<Props>(), {
  onSuccess: async () => {},
});

const { id, registryNumber, typeCode } = props.procedure;

const { closeDialog } = useDialogStore();

const stages = ref(null);

const procedure = ref({
  reacceptanceExplanation: null,
});
const errors = ref({});

const pickersDisabledDate = (date) => date < new Date(new Date().setHours(0, 0, 0, 0));

const stageStore = useProcedureStageComponentStore();
const stageComponent = computed(() => {
  return stageStore.getComponentByType(typeCode);
});

const approve = async () => {
  if (stages.value.validate && !(await stages.value.validate())) {
    return;
  }
  const formData = new FormData();
  formData.append('step', 'published');
  formData.append('data', JSON.stringify(procedure.value));
  try {
    await api.post(`/procedures/${id}/returnToStep`, formData);
    toast.info('Процедура возвращена успешно');
    await props.onSuccess();
    closeDialog();
  } catch (e) {
    toast.error(e.message);
  }
};
</script>

<style scoped>
.card {
  height: 100%;
}

.v-card-title {
  display: flex;
  justify-content: space-between;
}

.close-button:hover {
  cursor: pointer;
}

:deep(.stages) {
  box-shadow: none;
  padding: 0;
  margin-bottom: 0 !important;
  height: fit-content;
}

.v-card-actions {
  justify-content: end;
}
</style>
